import React from 'react'
import Main from '../AboutComponent/Main'
import AboutOurCompany from '../AboutComponent/AboutOurCompany'
import BrandsWeHaveWorked from '../AboutComponent/BrandsWeHaveWorked'
import OurAgencySnaps from '../AboutComponent/OurAgencySnaps'

const About = () => {
  return (
    <>
      <Main/>
      <AboutOurCompany/>
      <BrandsWeHaveWorked/>
      <OurAgencySnaps/>
    </>
  )
}

export default About
